<template lang="pug">
modal(:max-width="300")
	Detalle(:idUsuario="idUsuario" @cerrar="$emit('cerrar')")
</template>

<script>
import Detalle from '../common/detalle'
export default {
	props: ['idUsuario'],
	components: {
		Detalle
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-horaria/vue/listado/detalleUsuario.vue